function sortNavForReturn() {
  var nav = document.querySelector(".site-nav");
  if (!nav) {
    return;
  }

  nav.classList.remove("site-nav--ready");

  var order = [
    "main-link--shop",
    "main-link--skin-rituals",
    "main-link--subscriptions",
    "main-link--ingredients",
    "main-link--rewards",
    "main-link--where-to-begin"
  ];

  function el(id) {
    const element = document.getElementById(id);
    return element;
  }

  order.map(el).filter(Boolean).forEach(function(item) {
    nav.appendChild(item);
  });

  void nav.offsetHeight;

  nav.classList.add("site-nav--ready");
}

function sortMobileNavForReturn() {
  var menu = document.querySelector("#side-menu-list");
  if (!menu) {
    return;
  }

  menu.classList.remove("ready");

  var order = [
    "side-menu-b-shop-all-b",
    "side-menu-skin-rituals",
    "side-menu-subscriptions-17-savings",
    "side-menu-rewards",
    "side-menu-our-ingredients",
    "side-menu-where-to-begin",
    "side-menu-log-in-for-rewards",
    "side-menu-newsletter-sign-up",
    "side-menu-shop-bundles",
    "side-menu-window-to-the-kitchen"
  ];

  function el(id) {
    const element = document.getElementById(id);
    return element;
  }

  order.map(el).filter(Boolean).forEach(function(item) {
    menu.appendChild(item);
  });

  void menu.offsetHeight;

  menu.classList.add("ready");
}

function getCookie(name) {
  const escaped = name.replace(/([.*+?^${}()|\[\]\/\\])/g, '\\$1');
  const match = document.cookie.match(new RegExp('(?:^|; )' + escaped + '=([^;]*)'));
  const result = match ? decodeURIComponent(match[1]) : null;
  return result;
}

function saveCookie(name, value, days) {
  try {
    const d = new Date();
    d.setTime(d.getTime() + (days * 24 * 60 * 60 * 1000));
    const expires = "expires=" + d.toUTCString();
    const cookieStr = name + "=" + encodeURIComponent(value) + ";" + expires + "; path=/";
    document.cookie = cookieStr;
  } catch (e) {
  }
}

function runVisitNavSort() {
  const hasVisited = getCookie("hasVisited");
  const firstSession = getCookie("firstSession");

  if (hasVisited && !firstSession) {
    sortNavForReturn();
    sortMobileNavForReturn();
  } else {
    saveCookie("hasVisited", "true", 180);
    saveCookie("firstSession", "true", 1);

    document.querySelector(".site-nav")?.classList.add("site-nav--ready");
    document.querySelector("#side-menu-list")?.classList.add("ready");
  }
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", runVisitNavSort);
} else {
  runVisitNavSort();
}